import Flux from 'lib/flux';
import MessageConstants from 'constants/message';

const MessageStore = Flux.createStore({
  name: 'message',

  getInitialState() {
    return {
      sending: false,
      sendingCompleted: false,
      sendingErrors: {},
    };
  },

  actions: [
    [
      MessageConstants.SEND_MESSAGE,
      function (_contents) {
        this.state = this.state.merge({
          sending: true,
          sendingCompleted: false,
          sendingErrors: {},
        });
      },
    ],

    [
      MessageConstants.SEND_MESSAGE_COMPLETED,
      function () {
        this.state = this.state.merge({
          sending: false,
          sendingCompleted: true,
          sendingErrors: {},
        });
      },
    ],

    [
      MessageConstants.SEND_MESSAGE_FAILED,
      function (payload) {
        this.state = this.state.merge({
          sending: false,
          sendingErrors: payload.errors,
        });
      },
    ],
  ],
});

export default MessageStore;
